import Container from './editable/Container.js';
import Validator from 'validator';
import notification from 'notification-js';

export const mapping = ({data, path}) => {
  return {
    sidebyside: {
      title: data.title,
      column1: data.column1,
      column2: data.column2
    }
  }
}

const addMandatoryValidation = (fields) => {
  for (var i = 0, max = fields.length; i < max; i++) {
    fields[i].onfocus = (event) => {
      event.target.dataset.value = event.target.value;
    }

    fields[i].onblur = (event) => {
      let element = event.target;

      if (Validator.isNull(element.value)) {
        notification.notify( 'warning', 'This field should not be left empty the change has been reverted', {
          notification: {position: [ 'right', 'top' ]}
        });
        element.value = element.dataset.value;
        triggerEvent(element);
      }
    }
  }
}

const triggerEvent = (element) => {
  if ("createEvent" in document) {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("input", false, true);
    element.dispatchEvent(evt);
  } else {
    element.fireEvent("input");
  }
}

export const transform = ({modal, path, updateState}) => {
  let title = modal.el.getElementsByClassName('title')[0];
  let column1 = modal.el.getElementsByClassName('column1')[0];
  let column2 = modal.el.getElementsByClassName('column2')[0];

  let mandatoryFields = modal.el.getElementsByClassName('mandatory');
  addMandatoryValidation(mandatoryFields);

  return {
    sidebyside: {
      callback: function() {
        if (title.__dirty || column1.__dirty || column2.__dirty) {
          updateState();
        }
      }
    },
    'sidebyside.title': '.sidebyside_text_editor .title',
    'sidebyside.column1': '.sidebyside_text_editor .column1',
    'sidebyside.column2': '.sidebyside_text_editor .column2'
  }
};

export const getData = (currentState, editor) => {
  currentState.title = editor.sidebyside.title;
  currentState.column1 = editor.sidebyside.column1;
  currentState.column2 = editor.sidebyside.column2;

  return currentState;
}

export default function() {
  let template = `
    <div class="form overflowVertical">
      <div class="sidebyside_text_editor editor-fields span12">
        <label for="title">Title: </label>
        <input type="text" name="title" class="title mandatory" class="title" />
        <span class="span6 field-item-container">
          <label for="column1">Column 1: </label>
          <textarea name="column1" class="column1 mandatory"></textarea>
        </span>
        <span class="span6 field-item-container">
          <label for="column2">Column 2: </label>
          <textarea name="column2" class="column2 mandatory"></textarea>
        </span>
      </div>
    </div>
  `

  return `<div>
    ${template}
  </div>`;
};



// WEBPACK FOOTER //
// ./src/editors/SideBySideText.js